import { wsCall, requestHelper } from "../../../app/coreSlice";

const assetDetailsCall = async ({ setAssetDetails }, dispatch, state, { carToken }) => {
  const selectedLocation = state?.getIn(["carclub2"])?.defaultLocation;
  let rh = requestHelper(dispatch, "ASSET/DETAILS");
  let result;
  try {
    result = await wsCall({
      type: "ASSET",
      subType: "DETAILS",
      locationId: selectedLocation?.id,
      message: {
        carToken,
      },
    });
    setAssetDetails && dispatch(setAssetDetails({ ...result.asset, ...result }));
  } catch (_ex) {
    rh.error("Error getting asset.");
  }
  rh.close();

  return result;
};

export default assetDetailsCall;
